import axios from 'axios'
import { log, token } from './interceptors'

const apiUrl = process.env.REACT_APP_URL ? process.env.REACT_APP_URL : window.TRADING_APP_URL

const instance = axios.create({
	baseURL: apiUrl,
	data: {},
	headers: {},
	timeout: 180000
})

token(instance)
log(instance)
export default instance
